import { useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";

import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";

export const ConfluencePageBanner = () => {
    const intl = useIntl();
    const showAiBanner = FeatureGates.checkGate(
        "wac-uip-butter-bar-confluence-gate"
    );

    const aiBannerMessages: BannerProps = {
        identifier: "ConfluenceSoftwarePageTemplate.atlassian-intelligence_exp",
        text: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.banner-alert.atlassian-intelligence_exp",
            defaultMessage:
                "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };

    if (showAiBanner) {
        return <BannerAlert {...aiBannerMessages} />;
    }
    return null;
};
